export default __webpack_public_path__ + "static/media/harbolkick-category-merchandise.b2e6ac73.png";